module.exports = __webpack_public_path__ + "img/1722398.6a7b1ccb.png";